export default __webpack_public_path__ + "static/media/loading-bars.0d539a7d.svg";